import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { FiArrowLeft, FiFileText } from "react-icons/fi";
import { getHostels, getHostelFeeReceipts } from "../../services/hostelService";

export default function HostelFeeReceiptList() {
    const navigate = useNavigate();
    const [hostels, setHostels] = useState([]);
    const [hostel, setHostel] = useState("");
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getHostels()
            .then((res) => setHostels(res.data || []))
            .catch(() => toast.error("Failed to load hostels"));
    }, []);

    useEffect(() => {
        setLoading(true);
        const params = {};
        if (hostel) params.hostel = hostel;
        getHostelFeeReceipts(params)
            .then((res) => setReceipts(res.data || []))
            .catch((err) => toast.error(err.response?.data?.message || "Failed to load receipts"))
            .finally(() => setLoading(false));
    }, [hostel]);

    const totalCollected = receipts.reduce((sum, r) => sum + r.amountPaid, 0);

    return (
        <div>
            <div className="page-header">
                <div>
                    <h1 className="page-title">
                        <FiFileText /> Hostel Fee Receipts
                    </h1>
                    <p className="page-subtitle">
                        {receipts.length} receipt(s) · ₹{totalCollected.toLocaleString("en-IN")} collected
                    </p>
                </div>
                <button className="btn btn-outline" onClick={() => navigate("/hostels")}>
                    <FiArrowLeft /> Back
                </button>
            </div>

            <div className="card">
                <div className="filter-bar">
                    <label>Hostel:</label>
                    <select
                        className="form-control"
                        style={{ width: 200 }}
                        value={hostel}
                        onChange={(e) => setHostel(e.target.value)}
                    >
                        <option value="">All Hostels</option>
                        {hostels.map((h) => (
                            <option key={h._id} value={h._id}>
                                {h.name}
                            </option>
                        ))}
                    </select>
                </div>

                {loading ? (
                    <div className="loading-center">
                        <div className="spinner" />
                        Loading receipts...
                    </div>
                ) : receipts.length === 0 ? (
                    <div className="empty-state">
                        <p>No hostel fee receipts recorded yet.</p>
                    </div>
                ) : (
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Receipt No</th>
                                    <th>Student</th>
                                    <th>Hostel</th>
                                    <th>Installment</th>
                                    <th>Amount</th>
                                    <th>Date</th>
                                    <th>Mode</th>
                                </tr>
                            </thead>
                            <tbody>
                                {receipts.map((r) => (
                                    <tr key={r._id}>
                                        <td>
                                            <span className="badge badge-blue">{r.receiptNo}</span>
                                        </td>
                                        <td>
                                            {r.student?.fullName}
                                            {r.student?.rollNo ? ` (${r.student.rollNo})` : ""}
                                        </td>
                                        <td>{r.hostel?.name}</td>
                                        <td>{r.installmentLabel}</td>
                                        <td style={{ fontWeight: 600 }}>₹{r.amountPaid.toLocaleString("en-IN")}</td>
                                        <td>{r.paymentDate}</td>
                                        <td>{r.paymentMode}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
}